import { getSearchObject } from 'Helpers/Uri';

export function getParams(params) {
    let { query, page } = params;

    let queryString = typeof query !== 'undefined' ? query : '';
    let pageString = getPageString(page);
    let pageNumber = getPageNumberByString(pageString);
    
    if((typeof page === 'undefined' || !page) && (queryString && queryString.includes('page-'))){
        pageString = getPageString(queryString);
        pageNumber = getPageNumberByString(pageString);
        queryString = '';
    }

    return {
        query: queryString,
        pageString: pageString,
        pageNumber: pageNumber
    };
}

function getPageString(page){
    return typeof page !== 'undefined' && page ? page : 'page-1';
}

function getPageNumberByString(pageString) {
    let pageStringNumber = pageString ? pageString.replace('page-', '') : '';
    let pageNumber = pageStringNumber && !isNaN(pageStringNumber) ? parseInt(pageStringNumber) : 1;
    return pageNumber;
}

export function getUrlFilters(filters, location) {
    const searchParams = getSearchObject(location.search);
    let output = {};

    Object.keys(searchParams).map(searchParam => {
        if (typeof filters[searchParam] !== 'undefined'){
            if (filters[searchParam].hasOwnProperty('ignore')) {
                output[searchParam] = searchParams[searchParam];
            } else if (filters[searchParam].options && filters[searchParam].options.length) {
                const options = filters[searchParam].options;
                let avaiableOptions = options.map(option => {
                    return option.value;
                });

                output[searchParam] = avaiableOptions.indexOf(searchParams[searchParam]) > 0 ? searchParams[searchParam] : '';
            } else {
                output[searchParam] = '';
            }
        }
    });

    return output;
}



// WEBPACK FOOTER //
// ./src/helpers/Search.js